/* Package JSON Import will be here */
import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
/* Package JSON Import will be here */

/* Const,Let & Var will be here */
const spinnerIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
/* Const,Let & Var will be here */

export const Spinner = props => {
  return (
    <Spin tip={props.message} className="spinner-width" size={props.needLargeSize ? "large" : "medium"} />
  );
};

export const ButtonSpinner = props => {
  return (
    <Spin size="small" className="pl-2" />
  );
};

export const BannerPlaceholder = () => {
  return <div className="banner-placeholder" />;
};

export const ImageLoader = () => {
  return (
    <Spin size="small" className="item-top-bottom-center-full-height" />
  );
};

export const ParentSpinnerSection = (props) => {
  return (
    <Spin
      spinning={props.spinning}
      tip={props.message}
      indicator={spinnerIcon}
      className="spinner-width"
    >
      {props.children}
    </Spin>
  );
}